































import { Component, Vue } from "vue-property-decorator";
import { Icon, Button, Toast } from "vant";
import _ from "lodash";

@Component({
  name: "RiskDisclosure",
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button
  }
})
export default class RiskDisclosure extends Vue {
  isRead = false;
  readTime = 5;
  timer: any = null;

  created() {
    this.initScroll()
  }
  activated() {
    this.initScroll()
    // this.isRead = false;
    // const box3: any = document.getElementById("app");
    // this.$nextTick(() => {
    //   if(box3.scrollTo){
    //     box3.scrollTo(0,0)
    //   }else{
    //     box3.scrollTop = 0
    //   }
    //   
    //   
    //   let first = true;
    //   box3.onscroll = null;
    //   box3.onscroll = _.throttle(() => {
    //     
    //     const clientHeight = box3.clientHeight;
    //     const scrollTop = box3.scrollTop;
    //     const scrollHeight = box3.scrollHeight;
    //     
    //     
    //     if(first && scrollTop > 0){
    //       if(box3.scrollTo){
    //         box3.scrollTo(0,0)
    //       }else{
    //         box3.scrollTop = 0
    //       }
    //       first = false;
    //     }
    //     
    //     if (scrollTop + clientHeight + 10 >= scrollHeight) {
    //       this.isRead = true;
    //     }
    //   }, 100);
    // });


    // this.timer = setInterval(() => {
    //   if (this.readTime > 1) {
    //     this.readTime--;
    //   } else {
    //     this.isRead = true;
    //     this.readTime = 5;
    //     clearInterval(this.timer);
    //   }
    // }, 1000);
  }

  deactivated() {
    const box: any = document.getElementById("app");
    box.onscroll = null;
    // this.timer && clearInterval(this.timer);
  }

  beforeRouteEnter(){}

  initScroll(){
    this.isRead = false;
    this.$nextTick(() => {
      const box: any = document.getElementById("app");
      if(box.scrollTo){
        box.scrollTo(0,0)
      }else{
        box.scrollTop = 0
      }
      
      
      box.onscroll = null;
      let first = true;
      box.onscroll = _.throttle(() => {
        
        
        if((first && box.scrollTop > 0) || (this.$route.path !== location.pathname)){
          if(box.scrollTo){
            box.scrollTo(0,0)
            
          }else{
            box.scrollTop = 0
          }
          first = false
        }
        const clientHeight = box.clientHeight;
        const scrollTop = box.scrollTop;
        const scrollHeight = box.scrollHeight;
        
        
        
        if (scrollTop + clientHeight + 10 >= scrollHeight) {
          this.isRead = true;
        }
      }, 100);
    });
  }

  isScrollBottom() {}

  handleNext() {
    if (!this.isRead) {
      return Toast(this.$t("open_account.risk_disclosure.toast_fail_text"));
    }
    this.$router.push({ name: "RiskDisclosure", query: this.$route.query });
    setTimeout(()=>{
      const box: any = document.getElementById("app");
      if(box.scrollTo){
        box.scrollTo(0,0)
      }else{
        box.scrollTop = 0
      }
    },0)
    // this.$router.push({
    //   path: "/customer_payments",
    //   query: this.$route.query
    // });
  }
}
